import { configureStore } from '@mhub/web-redux-utilities';
import thunk from 'redux-thunk';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';

import './reset.css';
import './index.css';

import rootReducer from './redux/reducers';
import { trackInAppHistoryNavigation } from './utils/bookingHandoff';

export const history = createBrowserHistory();
trackInAppHistoryNavigation(history);

export const store = configureStore(
  connectRouter(history)(rootReducer),
  {},
  thunk,
  routerMiddleware(history),
);
